// Wave 20.47b — aero.chat cheer palette.
//
// Custom-designed branded glyphs — NOT Unicode emoji. Each cheer
// renders via its own SVG component from cheerGlyphs.tsx so the
// visual identity is ours (brand green, distinctive silhouettes)
// and viewers on any OS see the same thing.
//
// The `key` is the durable server identifier; the glyph + animation
// + color are presentation-only and can evolve without a DB change.

import type { ComponentType } from 'react';
import {
  AeroBoltGlyph,
  CadenceGlyph,
  DraftGlyph,
  FocusGlyph,
  GoatGlyph,
  SummitGlyph,
  WattsGlyph,
  WindStreakGlyph,
} from './cheerGlyphs';

export type CheerAnimation =
  | 'pulse'
  | 'streak'
  | 'rise'
  | 'roll'
  | 'flicker'
  | 'zoom'
  | 'rainbow'
  | 'bounce';

export interface CheerDef {
  key: string;
  Glyph: ComponentType<{ size?: number; color?: string; id?: string }>;
  label: string;
  animation: CheerAnimation;
  color: string;
}

export const CHEER_PALETTE: CheerDef[] = [
  { key: 'aero',    Glyph: AeroBoltGlyph,    label: 'Aero',      animation: 'pulse',   color: '#6AFF45' },
  { key: 'wind',    Glyph: WindStreakGlyph,  label: 'Tailwind',  animation: 'streak',  color: '#7EEBFF' },
  { key: 'summit',  Glyph: SummitGlyph,      label: 'Summit',    animation: 'rise',    color: '#B4F5D8' },
  { key: 'cadence', Glyph: CadenceGlyph,     label: 'Cadence',   animation: 'roll',    color: '#8DFF7A' },
  { key: 'watts',   Glyph: WattsGlyph,       label: 'Watts',     animation: 'flicker', color: '#FFB86A' },
  { key: 'focus',   Glyph: FocusGlyph,       label: 'Locked in', animation: 'zoom',    color: '#6AFF45' },
  { key: 'draft',   Glyph: DraftGlyph,       label: 'Draft',     animation: 'rainbow', color: '#C7B3FF' },
  { key: 'goat',    Glyph: GoatGlyph,        label: 'GOAT',      animation: 'bounce',  color: '#FFD86A' },
];

export const CHEER_BY_KEY: Record<string, CheerDef> = Object.fromEntries(
  CHEER_PALETTE.map((c) => [c.key, c]),
);
